import { FeedService } from '@xq/infrastructure';
import { StreamClient } from 'getstream';

export class RemoveEmojiReactionUseCase {
  static execute(client: StreamClient, emojiId: string) {
    return FeedService.getInstance(client).removeEmojiReaction(emojiId);
  }
}
